import firebase from 'firebase/app';
import 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

const config = {
    apiKey: "AIzaSyC6FxYK4FrZUWS-jMgnlE8jTHHy4owLfp0",
    authDomain: "tree-tracker-88ff6.firebaseapp.com",
    databaseURL: "https://tree-tracker-88ff6.firebaseio.com",
    projectId: "tree-tracker-88ff6",
    storageBucket: "tree-tracker-88ff6.appspot.com",
    messagingSenderId: "489315901623"
};
const fire = firebase.initializeApp(config)
export default fire



// WEBPACK FOOTER //
// ./src/config/Fire.js